import "./index.scss";

import { CircularProgress } from "@mui/material";
import React, { FC, memo } from "react";

interface Props {
  isScreenLoader: boolean;
  containerStyle?: object;
  size?: number;
}

const ScreenLoader: FC<Props> = ({ isScreenLoader, containerStyle, size = 40 }) => {
  if (!isScreenLoader) {
    return null;
  }

  return (
    <div className={"screen-loader"} style={containerStyle}>
      <CircularProgress size={size} disableShrink color="success" />
    </div>
  );
};

export default memo(ScreenLoader);
